import { useSelector } from 'react-redux';
import React from 'react';

import PurchasingStatistics from './PurchasingStatistics';
import { getOrganisationView } from 'selectors/organisation';
import VCFundingStats from './VCFundingStats';
import AcquisitionStats from './AcquisitionStats';
import {
  ORGANISATIONACQUISITIONSVIEW,
  ORGANISATIONINVESTMENTSVIEW,
  ORGANISATIONPURCHASINGVIEW,
  ORGANISATIONVCFUNDINGVIEW,
  ORGANISATIONSUBSIDIARIESVIEW,
} from '../helpers';
import InvestmentStats from './InvestmentStats';
import SubsidiariesStatistics from './SubsidiariesStatistics';

// Stats for the specialised views only, rendered below the tab bar and above
// that tab's own pane. The People/Countries/Activities cards for the searchable
// views are ResearcherStatistics, in the same position further down the column
// — see the render in Organisation/index.js.
const Statistics = ({ organisation, loading }) => {
  const view = useSelector(getOrganisationView);

  let stats;

  if (view === ORGANISATIONPURCHASINGVIEW) {
    stats = (
      <PurchasingStatistics organisation={organisation} loading={loading} />
    );
  } else if (view === ORGANISATIONVCFUNDINGVIEW) {
    stats = <VCFundingStats organisation={organisation} loading={loading} />;
  } else if (view === ORGANISATIONACQUISITIONSVIEW) {
    stats = <AcquisitionStats organisation={organisation} loading={loading} />;
  } else if (view === ORGANISATIONINVESTMENTSVIEW) {
    stats = <InvestmentStats organisation={organisation} loading={loading} />;
  } else if (view === ORGANISATIONSUBSIDIARIESVIEW) {
    stats = (
      <SubsidiariesStatistics organisation={organisation} loading={loading} />
    );
  } else {
    stats = null;
  }

  return stats;
};

export default Statistics;
